import { cap } from '../../State'
import { translations } from '../../translations'
import { PercentageInfoNumber } from './PercentageInfoNumber'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

/** Configurazione icona e badge per ogni card di dettaglio statistiche */
const DETAIL_CARD_META = {
  elaborated: {
    icon: 'pi-check',
    iconBg: 'var(--success-tint)',
    iconColor: 'var(--success)',
    badgeClass: 'nbadge--ok'
  },
  handled: {
    icon: 'pi-user',
    iconBg: 'var(--info-tint)',
    iconColor: 'var(--info)',
    badgeClass: 'nbadge--info'
  },
  errors: {
    icon: 'pi-exclamation-triangle',
    iconBg: 'var(--danger-tint)',
    iconColor: 'var(--danger)',
    badgeClass: 'nbadge--err'
  }
}

/**
 * Card dettagliata per statistiche con header, barra percentuale principale e dettagli.
 * @param {Object} props - Proprietà del componente
 * @param {string} props.variant - Identificativo card per la configurazione icona/badge ('elaborated' | 'handled' | 'errors')
 * @param {string} props.title - Titolo della card
 * @param {string} props.countLabel - Label per la sezione dettagli
 * @param {number} props.countValue - Valore del conteggio principale
 * @param {number} props.totalCount - Totale delle conversazioni
 * @param {Object} props.data - Dati delle conversazioni
 * @param {Array} props.filterMain - Filtri principali per le percentuali
 * @param {Array} props.filterDetails - Filtri per i dettagli
 * @param {Array} props.percentageStateTotal - Stato delle percentuali totali
 * @param {boolean} props.showDetailsComponent - Mostra componente dettagli aggiuntivo
 * @param {JSX.Element} props.detailsComponent - Componente dettagli da mostrare
 * @returns {JSX.Element} Card delle statistiche dettagliate
 */
const StatisticsCard = ({
  variant,
  title,
  countLabel,
  countValue,
  totalCount,
  data,
  filterMain,
  filterDetails,
  percentageStateTotal,
  showDetailsComponent = false,
  detailsComponent = null
}) => {
  const meta = DETAIL_CARD_META[variant] || DETAIL_CARD_META.elaborated

  return (
    <div className="ncard stats-detail-card">
      <div className="ncard__head">
        <div className="ncard__ico" style={{ background: meta.iconBg, color: meta.iconColor }}>
          <i className={`pi ${meta.icon}`} style={{ fontSize: 16 }} />
        </div>
        <div>
          <h3 className="ncard__title">{title}</h3>
        </div>
        <div className="ncard__head-actions">
          <span className={`nbadge ${meta.badgeClass}`.trim()} style={meta.badgeStyle}>
            {countValue || 0} / {totalCount || 0}
          </span>
        </div>
      </div>
      <div className="ncard__body stats-detail-card-body">
        {filterMain.map((itemLabel, index) => (
          <PercentageInfoNumber
            main
            noTotal
            overlayLabel={t.stPercTotale}
            data={data[itemLabel.label]}
            key={index}
            itemLabel={itemLabel}
            percentageStateTotal={percentageStateTotal}
          />
        ))}

        {filterDetails.length > 0 && (
          <>
            <div className="stats-detail-card-section-title">{countLabel}</div>
            {filterDetails.map((itemLabel, index) => (
              <PercentageInfoNumber
                data={data[itemLabel.label]}
                key={index}
                itemLabel={itemLabel}
                percentageStateTotal={percentageStateTotal}
              />
            ))}
          </>
        )}

        {showDetailsComponent && (
          <>
            <div className="stats-detail-card-section-title">{countLabel}</div>
            {detailsComponent}
          </>
        )}
      </div>
    </div>
  )
}

export default StatisticsCard
